import { render, staticRenderFns } from "./google_chart.vue?vue&type=template&id=44d1dfa6"
import script from "./google_chart.vue?vue&type=script&lang=js"
export * from "./google_chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports